<template>
  <Standaloneform msg="Standaloneform"/>
</template>

<script>
import Standaloneform from './components/Standaloneform.vue'

export default {
  name: 'Agilent Standaloneform',
  components: {
    Standaloneform
  }
}
</script>

<style>
#app{
  height: 100%;
}
html, body {
  height: 100%;
  margin: 0;
}

.container_flex{
  height: 100%;
  display: flex;
  flex-direction: column;
}

.header{

}
.middle_body_flex{
  flex: 1;
  overflow: auto;
  /*background: pink;*/
}
.footer{

}
body{
  padding: 0;
  margin: 0;
  background-color: #E5E5E5;
} 
.header{
  background-color: #0085D5;
}
.logo{
  padding: 12px 0;  
}
.content{
  margin: 0 auto;
  max-width: 1140px;
}
a{
  text-decoration: none;
  color: #057FC8;
}
.middle_content{
  background-color: white;
  max-width: 598px;
  margin: 63px auto 1px;
  padding: 12px 12px;
}
.head_tips{
  height: 48px;
  float: right;
}
ul.head_tips{
  list-style: none;
  padding: 0;
  margin: 0;
}

ul.head_tips li{
  display: inline;
  font-family: Noto Sans,Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 49px;
  letter-spacing: 0em;
  text-align: center;
  color: #53565A;
  padding: 10px 10px;
  cursor: pointer;
}
ul.head_tips li.active {
  font-family: Noto Sans,Roboto;
  font-weight: 700;
  border-bottom: 3px solid #0085D5;
  color: #0085D5;
}

.clearfix {
  overflow: auto;
}

.clearfix::after {
  content: "";
  clear: both;
  display: table;
}
.title{
  padding: 42px 0 12px;
  clear: both;  
  clear: both;
}
.title h1{
  text-align: center;
  font-family: Noto Sans,Roboto;
  font-size: 36px;
  font-weight: 400;
  line-height: 49px;
  letter-spacing: 0em;
  text-align: center;
  margin: 0;
}
.pannel_body{
  padding: 0 48px;
}
.text p{
  font-family: Noto Sans,Roboto;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 1px;
  text-align: left;
}

.otwf-chkbox{
    display:inline-block;
    margin-bottom: 17px;
    width:100%
}
.otwf-chkbox label{
    position:relative;
    display:inline-flex;
    align-items:center;
    cursor:pointer;
    font-family: Noto Sans, Roboto;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    min-height:20px;
    padding-left:30px
}
.otwf-chkbox label::before,.otwf-chkbox label::after{
    position:absolute;
    content:"";
    display:inline-block;
    border-radius:3px;
    top: 2px;
}
.otwf-chkbox label::before{
  height: 16px;
  width: 16px;
  border: 2px solid;
  left:0px
}
.otwf-chkbox label::after{
    height:5px;
    width:9px;
    border-left:3px solid;
    border-bottom:3px solid;
    transform:rotate(-45deg);
    -o-transform:rotate(-45deg);
    -ms-transform:rotate(-45deg);
    -webkit-transform:rotate(-45deg);
    left:4px;
    top:5px
}
.otwf-chkbox input{
    position:absolute;
    opacity:0;
    width:20px;
    height:20px
}
.otwf-chkbox input+label::after{
    content:none;
    color:#fff
}
.otwf-chkbox input:checked+label::after{
    content:""
}
.otwf-chkbox input:focus+label::before{
    outline-width:2px;
    outline-style:auto
}

.ot-el{
    clear:both
}
input:not([type=radio]):not([type=checkbox]){
    display:block;
    width:calc(100% - 20px);
    padding-left:10px;
    min-height:28px;
    border-radius:5px;
    border:1px solid
}
.ot-err-show .ot-error{
  display:block !important;
}

.ot-err-show label.ot-label{
  color: #D6001C !important;
}

.ot-err-show label::before {
  border-color:#D6001C  !important;
}

.ot-error-prefix {
  background-color: #D6001C;
  width: 18px;
  height: 18px;
  border-radius: 9px;
  display: inline-block;
  color: white;
  vertical-align: text-top;
  text-align: center;
  margin-right: 6px;
  line-height: 19px;
}

.ot-error{
  color: #D6001C;
  display:none;
  margin-top:5px;
  /*font-family: Font Awesome 6 Pro, Roboto;*/
  font-family: Noto Sans,Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  clear:both
}

.ot-show{
  display: block;
}

.ot-de .ot-label {
}
.ot-de input:not([type="radio"]):not([type="checkbox"]){
    background-color:#FFFFFF;
    border-color:#B1B3B3;
}
.ot-de ::placeholder {
    color:#53565A;
    opacity:1;
}
.ot-de ::-ms-input-placeholder,.ot-de :-ms-input-placeholder {
    color:#53565A;
}
.otwf-chkbox label::before {
    border-color:#384350;
}
.otwf-chkbox input:checked ~ label::before {
    background-color:#0085D5;
}
.otwf-chkbox label {
     align-items: flex-start !important;
}
.ot-contentblock p {
     font-size: 14px !important;
     padding-left: 30px !important;
}


.ot-asterisk {
  color: red;
  display: inline-block;
  width: 7px;
  height: 10px;  
  margin-right: 7px;
}    
.purpose_desc {
    margin: 38px 0px 6px;
}
.input_boxs{
  margin-bottom: 40px;
}
.ot-txt{
  margin-bottom: 20px;
}
.ot-txt label{
  font-family: Noto Sans,Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0em;
  text-align: left;
  margin: 0;
  line-height: 30px;
}

.ot-txt input{
  width: 100%;
  height: 38px;
  padding: 5px;
  border-radius: 5px;
  border: 1px;
  margin: 0;
  line-height: 32px;
  font-family: Noto Sans,Roboto;
  font-size: 14px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1px;
  text-align: left;
  
}
.ot-txt input:focus{
  outline:none;
}
.footer{
  text-align: center;
  margin: 40px 0 0px;
  padding-bottom: 60px;
}

.footer ul{
  list-style: none;
  padding-left: 0;
}

.footer ul li{
  display: inline-block;
  padding: 0px 30px; 
  border-right: 1px solid #343740;

  font-family: Noto Sans,Roboto;
  font-size: 11px;
  font-weight: 400;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: center;
}
.footer ul li:after{

}


.footer ul li:last-child{
  border-right: 0px solid #343740;
}
.footer ul li a{
  text-decoration: none;
  color: #057FC8;
}

.ot-btns {
  width: 100%;
  margin-bottom: 38px;
}
.ot-submit{
  border-radius: 5px;
  width: 100%;
  padding: 6px 0;
  border: 1px solid;
  cursor: pointer;
  background: #0085D5;
  color: white;
  font-family: Noto Sans,Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 38px;
  letter-spacing: 0em;
  text-align: center;
}

.ot-submit:disabled{
    background: gray;
    cursor: inherit;
}

.language-en ul.head_tips li.active{
  font-family: Roboto !important;
}

.language-en .title h1{
  font-family: Roboto !important;
}
.language-en .text p{
  font-family: Roboto !important;
}

.language-en .ot-txt input, .language-en .ot-txt label{
  font-family: Roboto !important;
}


@media only screen and (max-width: 600px){
  .logo{
    padding: 0
  }
  .middle_content{
    margin-top: 0px;
  }
  .pannel_body {
      padding: 0 10px;
  }  
  .footer ul li{
    padding: 0px 8px;
  }
}

</style>
